const sectionSchema = {
  type: 'object',
  required: ['title'],
  properties: {
    title: {
      type: 'string',
      title: 'Section title',
      default: '',
    },
    displayTitle: {
      type: 'boolean',
      title: 'Display title',
      default: false,
    },
    height: {
      type: 'string',
      title: 'Section height',
      enum: ['fit-content', 'half', 'two-thirds', 'full'],
      enumNames: ['Fit content', '1/2 screen', '2/3 screen', 'Fullscreen'],
      default: 'fit-content',
    },
  },
};

export default sectionSchema;
